import {AnyAction} from 'redux';

import * as at from './login_action_types';

export interface LoginState {
  idleTimeReset: boolean;
}

const defaultState: LoginState = {
  idleTimeReset: false,
};

function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case at.RESET_IDLE_TIME: {
      const idleTimeReset = action.payload;
      return {...state, idleTimeReset};
    }
  }
  return state;
}

export default reducer;
